import { useState } from "react";

// Tetap dipertahankan untuk diaktifkan kembali saat distribusi Android Absensi dibutuhkan.
const SHOW_DOWNLOAD_ANDROID_ABSENSI_MENU = false;

function SideMenu({ isOpen, toggle, onChangePage, onLogOut, authIdentity = {}, onOpenDownloadModal }) {
  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const userLevel = Number(authIdentity?.user_level ?? 0);
  const canDownloadAndroidAbsensi = userLevel >= 8;
  const nama = String(authIdentity?.nama || "").trim();

  return (
    <aside
      className={`bg-slate-800 text-white transition-all duration-300
      ${isOpen ? "w-64" : "w-16"}`}
    >
      <div className="flex flex-col h-screen">
      {/* MINIMIZE MENU */}
        <div className="flex items-center justify-between p-4">
          {isOpen && <span className="font-bold">NEW SIMPUA</span>}
          <div className="flex-grow-1"></div>
          <button onClick={toggle}> {isOpen? <i className="fa fa-chevron-left"></i> : <i className="fa fa-chevron-right"></i>}</button>
        </div>  
      {/* MENU */}
        <nav className="px-2">
          {/* DASHBOARD */}
          <div  className="p-2 hover:bg-slate-700 rounded cursor-pointer" 
          onClick={() => onChangePage("Dashboard")}
          >
            🏦 {isOpen && "Dashboard"}
          </div>

          {/* ACTION */} 
          <div  className="p-2 hover:bg-slate-700 rounded cursor-pointer" 
          onClick={() => onChangePage("Page15")}
          >
            ⚡ {isOpen && "OTF Event"}
          </div>

          {/** 
          <div>
            <div
              className="p-2 hover:bg-slate-700 rounded cursor-pointer flex justify-between"
              onClick={() => handleToggleMenu("transaksi")}
            >
              <span>⚡{isOpen && "Action"}</span>
              {isOpen && <span>{openMenu === "transaksi" ? "▾" : "▸"}</span>}
            </div>

            {openMenu === "transaksi" && isOpen && (
              <div className="ml-6 text-sm">
                <div className="p-2 hover:bg-slate-700 rounded cursor-pointer"
                onClick={() => onChangePage("Page2")}
                >
                  Update KM
                </div>
                <div className="p-2 hover:bg-slate-700 rounded cursor-pointer">
                  Maintenance
                </div>
                <div className="p-2 hover:bg-slate-700 rounded cursor-pointer">
                  Order
                </div>
              </div>
            )}
          </div>
            */}   

          {/* INVENTORI */} 
          <div  className="p-2 hover:bg-slate-700 rounded cursor-pointer" 
          onClick={() => onChangePage("Page23")}
          >
             📦 {isOpen && "Workshop Event"}
          </div>  

          {/* FINANCE */} 
          <div  className="p-2 hover:bg-slate-700 rounded cursor-pointer" 
          onClick={() => onChangePage("Page13")}
          >
            💲 {isOpen && "Keuangan"}
          </div>  

          {/* MONITORING DAN LAPORAN */} 
          <div  className="p-2 hover:bg-slate-700 rounded cursor-pointer" 
          onClick={() => onChangePage("Page33")}
          >
            📩 {isOpen && "Laporan"}
          </div>    
            
          {
          kodeCabangUser === 'C-1' && /* ATRIBUTE DATA */ 
          <div  className="p-2 hover:bg-slate-700 rounded cursor-pointer" 
          onClick={() => onChangePage("Page6")}
          >
            🧮 {isOpen && "Atribute Data"}
          </div>
          }   

          {/* SETTINGS */}
          <div
            className="p-2 hover:bg-slate-700 rounded cursor-pointer"
            onClick={() => onChangePage("Admin")}
          >
            ⚙️ {isOpen && "Settings"}
          </div>

          {SHOW_DOWNLOAD_ANDROID_ABSENSI_MENU && canDownloadAndroidAbsensi && (
            <div
              className="p-2 hover:bg-slate-700 rounded cursor-pointer"
              onClick={() => {
                if (typeof onOpenDownloadModal === "function") onOpenDownloadModal();
              }}
            >
              📥 {isOpen && "Download Android Absensi"}
            </div>
          )}

          {/* LOG OUT */}
          <div className="p-2 hover:bg-slate-700 rounded cursor-pointer"
          onClick={() => onLogOut("logout")}>
            ➡️ {isOpen && "Keluar"}
          </div>
        </nav>
      {/* FOOTER */}  
        <div className="flex-grow-1"></div>
        <div><i className="fa fa-user-circle p-4 me-4 fa-lg"></i>  
          <span className="me-3">{isOpen ? nama : null}</span></div>    
      </div>
    </aside>
  );
}

export function Sidebar({ children, onChangePage, onLogOut, authIdentity = {}, onOpenDownloadModal }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen">
      <SideMenu
        isOpen={sidebarOpen}
        toggle={() => setSidebarOpen(prev => !prev)}
        onChangePage={onChangePage}
        onLogOut={onLogOut}
        authIdentity={authIdentity}
        onOpenDownloadModal={onOpenDownloadModal}
      />

      <main className="flex bg-gray-50">
        {children}
      </main>
    </div>
  );
}
